"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var CommentCreateWrapper = function CommentCreateWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "commentText", _descriptor, _this);
      _initializerDefineProperty(_this, "initialText", _descriptor2, _this);
      _initializerDefineProperty(_this, "suggestedText", _descriptor3, _this);
      _initializerDefineProperty(_this, "caretPosition", _descriptor4, _this);
      _initializerDefineProperty(_this, "postAsUser", _descriptor5, _this);
      _initializerDefineProperty(_this, "showFirstCommentModal", _descriptor6, _this);
      _this.onChangeComment = function (value, caretPosition) {
        _this.commentText = value;
        _this.caretPosition = caretPosition;
      };
      _this.setInitialText = function (text) {
        _this.initialText = text;
        _this.commentText = text;
      };
      _this.applySuggestedText = function (text) {
        var _this$commentText;
        if (((_this$commentText = _this.commentText) !== null && _this$commentText !== void 0 ? _this$commentText : '') === '' && text) {
          _this.commentText = text;
        }
      };
      _this.onSubmit = function () {
        if (_this.needsFirstCommentConfirmation) {
          _this.showFirstCommentModal = true;
          return;
        }
        _this.submitComment();
      };
      _this.onConfirmFirstComment = function () {
        _this.showFirstCommentModal = false;
        if (_state.AppUI.userIsLoaded) {
          _state.AppUI.user.set('hasPostedComment', true);
        }
        _this.submitComment();
      };
      _this.onCancelFirstComment = function () {
        _this.showFirstCommentModal = false;
      };
      _this.submitComment = function () {
        if (!_state.AppUI.layout.isNative && _this.props.namespace && !_this.props.edit) {
          setTimeout(_this.showAnimation, 50);
        }
        if (_this.props.onSubmitComment) {
          _this.props.onSubmitComment(_this.commentText);
        } else {
          var _DeckUI$currentCard, _DeckUI$currentCard2;
          if ((_DeckUI$currentCard = _state.DeckUI.currentCard) !== null && _DeckUI$currentCard !== void 0 && _DeckUI$currentCard.sentence && typeof _state.DeckUI.currentCard.sentence.set === 'function') {
            _state.DeckUI.currentCard.sentence.set('commentsCount', _state.DeckUI.currentCard.sentence.commentsCount + 1);
          }
          if ((_DeckUI$currentCard2 = _state.DeckUI.currentCard) !== null && _DeckUI$currentCard2 !== void 0 && _DeckUI$currentCard2.word && typeof _state.DeckUI.currentCard.word.set === 'function') {
            _state.DeckUI.currentCard.word.set('commentsCount', _state.DeckUI.currentCard.word.commentsCount + 1);
          }
          _state.ForumUI.onCreateComment({
            userId: _this.postAsUser ? _this.postAsUser.id : null,
            commentableId: _this.props.commentable ? _this.props.commentable.id : _this.props.commentableId,
            parentId: _this.props.parentId,
            commentableType: _this.props.commentableType,
            text: _this.commentText,
            wordId: _this.props.wordId,
            conceptId: _this.props.conceptId,
            faqItemId: _this.props.faqItemId,
            sentenceId: _this.props.sentenceId,
            debugInfo: _this.props.debugInfo
          }, _this.afterCreateComment);
          _this.onResetComment();
          if (_this.props.afterSubmitComment) {
            _this.props.afterSubmitComment();
          }
        }
      };
      _this.afterCreateComment = function (resp) {
        _state.AppUI.createEvent('comment - post', {
          comment_type: _this.props.commentableType,
          comment_type_id: resp.commentableId || (_this.props.commentable ? _this.props.commentable.id : _this.props.commentableId)
        });
        _state.ForumUI.onAfterCreateComment(resp);
        if (_this.props.afterCreateComment) {
          _this.props.afterCreateComment(resp);
        }
      };
      _this.showAnimation = function () {
        _state.AppUI.createXpAnimation({
          type: 'chat-message',
          xp: 2,
          namespace: _this.props.namespace
        });
      };
      _this.onResetComment = function () {
        _this.commentText = _this.props.edit ? _this.props.text : '';
        _this.initialText = _this.commentText;
      };
      if (_this.props.text) {
        _this.setInitialText(_this.props.text);
      }
      _this.applySuggestedText(_this.props.suggestedText);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "disable",
      get: function get() {
        return this.commentText === this.initialText;
      }
    }, {
      key: "id",
      get: function get() {
        if (this.props.commentable) {
          return "comment-create-input-".concat(this.props.commentable.id);
        } else {
          return 'comment-create-input';
        }
      }
    }, {
      key: "needsFirstCommentConfirmation",
      get: function get() {
        if (this.props.edit || this.props.onSubmitComment) {
          return false;
        }
        return _state.AppUI.userIsLoaded && !_state.AppUI.user.hasPostedComment;
      }
    }, {
      key: "firstCommentModalTitle",
      get: function get() {
        return 'Post Comment?';
      }
    }, {
      key: "firstCommentModalMessage",
      get: function get() {
        return 'Comments are public and can be seen by other users. Do you want to post this?';
      }
    }, {
      key: "firstCommentConfirmText",
      get: function get() {
        return 'Post';
      }
    }, {
      key: "firstCommentCancelText",
      get: function get() {
        return 'Cancel';
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.text && prevProps.text !== this.props.text) {
          this.setInitialText(this.props.text);
        }
        if (this.props.suggestedText && prevProps.suggestedText !== this.props.suggestedText) {
          this.applySuggestedText(this.props.suggestedText);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _state.AppUI.xpState.clearXpAnimationNamespace(this.props.namespace);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          disable: this.disable,
          id: this.id,
          commentText: this.commentText,
          initialText: this.initialText,
          caretPosition: this.caretPosition,
          postAsUser: this.postAsUser,
          onChangeComment: this.onChangeComment,
          setInitialText: this.setInitialText,
          insertText: this.insertText,
          onSubmit: this.onSubmit,
          showAnimation: this.showAnimation,
          onResetComment: this.onResetComment,
          showFirstCommentModal: this.showFirstCommentModal,
          firstCommentModalTitle: this.firstCommentModalTitle,
          firstCommentModalMessage: this.firstCommentModalMessage,
          firstCommentConfirmText: this.firstCommentConfirmText,
          firstCommentCancelText: this.firstCommentCancelText,
          onConfirmFirstComment: this.onConfirmFirstComment,
          onCancelFirstComment: this.onCancelFirstComment
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "commentText", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "initialText", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "suggestedText", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "caretPosition", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "postAsUser", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "showFirstCommentModal", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "disable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disable"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "id", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "id"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "needsFirstCommentConfirmation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "needsFirstCommentConfirmation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "firstCommentModalTitle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "firstCommentModalTitle"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "firstCommentModalMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "firstCommentModalMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "firstCommentConfirmText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "firstCommentConfirmText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "firstCommentCancelText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "firstCommentCancelText"), _class2.prototype), _class2)) || _class;
};
CommentCreateWrapper.displayName = 'CommentCreateWrapper';
var _default = exports["default"] = CommentCreateWrapper;